/* UGMA custom product page interactions */
(function () {
  function init(root) {
    if (!root || root.dataset.ugmaInit === '1') return;
    root.dataset.ugmaInit = '1';

    /* ---------- Gallery ---------- */
    var gallery = root.querySelector('[data-ugma-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-ugma-track]');
      var slides = track ? track.children.length : 0;
      var dots = gallery.querySelectorAll('[data-ugma-dot]');
      var index = 0;

      var thumbsEl = gallery.querySelector('[data-ugma-thumbs]');

      var go = function (i) {
        if (slides === 0) return;
        index = (i + slides) % slides;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        dots.forEach(function (d, di) {
          var active = di === index;
          d.setAttribute('aria-current', active ? 'true' : 'false');
          if (active && thumbsEl) {
            d.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          }
        });
      };

      var prev = gallery.querySelector('[data-ugma-prev]');
      var next = gallery.querySelector('[data-ugma-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      var thumbPrev = gallery.querySelector('[data-ugma-thumb-prev]');
      var thumbNext = gallery.querySelector('[data-ugma-thumb-next]');
      if (thumbPrev) thumbPrev.addEventListener('click', function () { go(index - 1); });
      if (thumbNext) thumbNext.addEventListener('click', function () { go(index + 1); });

      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.dataset.ugmaDot, 10)); });
      });
    }

    /* ---------- Tabs ---------- */
    var tabs = root.querySelectorAll('[data-ugma-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.ugmaTab;
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        root.querySelectorAll('[data-ugma-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.ugmaPanel !== key;
        });
      });
    });

    /* ---------- Quantity stepper ---------- */
    var qtyInput = root.querySelector('[data-ugma-qty-input]');
    var setQty = function (val) {
      if (!qtyInput) return;
      var n = Math.max(1, parseInt(val, 10) || 1);
      qtyInput.value = n;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    };
    var minus = root.querySelector('[data-ugma-qty-minus]');
    var plus = root.querySelector('[data-ugma-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        if (parseInt(qtyInput.value, 10) < 1 || isNaN(parseInt(qtyInput.value, 10))) return;
      });
    }

    /* ---------- Bundle selector ---------- */
    var bundleCards = root.querySelectorAll('[data-ugma-bundle]');
    var priceCurrentEl = root.querySelector('[data-ugma-price] .ugma-price__current');
    var priceCompareEl = root.querySelector('[data-ugma-price] .ugma-price__compare');
    var priceSaveEl = root.querySelector('[data-ugma-price] .ugma-price__save');
    var stickyCurrentEl = root.querySelector('[data-ugma-sticky-current]');
    var stickyCompareEl = root.querySelector('[data-ugma-sticky-compare]');

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var selectedBundleQty = 1;

    // Server-rendered hidden quantity field (in buy-buttons.liquid).
    // JS just updates its value — so it is always present before Shiprocket reads the form.
    var qtyHidden = form ? form.querySelector('[data-ugma-qty-field]') : null;

    var setBundleQty = function (qty) {
      qty = Math.max(1, parseInt(qty, 10) || 1);
      selectedBundleQty = qty;
      setQty(qty);
      if (qtyHidden) qtyHidden.value = qty;
    };


    var defaultCard = root.querySelector('[data-ugma-bundle].is-selected');
    if (defaultCard) setBundleQty(defaultCard.dataset.ugmaQty);

    bundleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        bundleCards.forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
          c.setAttribute('aria-checked', c === card ? 'true' : 'false');
        });
        setBundleQty(card.dataset.ugmaQty);
        var bundlePriceEl = card.querySelector('.ugma-bundle__price');
        if (bundlePriceEl) {
          var bundlePriceText = bundlePriceEl.textContent.trim();
          if (priceCurrentEl) priceCurrentEl.textContent = bundlePriceText;
          if (stickyCurrentEl) stickyCurrentEl.textContent = bundlePriceText;
        }
        if (priceCompareEl) priceCompareEl.style.display = 'none';
        if (priceSaveEl) priceSaveEl.style.display = 'none';
        if (stickyCompareEl) stickyCompareEl.style.display = 'none';
      });
    });

    /* ---------- Buy Now → cart + Razorpay Magic Checkout intercepts /checkout ---------- */
    var buyNowBtn = root.querySelector('[data-ugma-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var variantInput = form ? form.querySelector('[name="id"]') : null;
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Please wait…';
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: selectedBundleQty })
            });
          })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            buyNowBtn.disabled = false;
            buyNowBtn.textContent = 'Buy it now';
          });
      });
    }

    /* ---------- Coupon copy ---------- */
    root.querySelectorAll('[data-ugma-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.dataset.ugmaCopy;
        var done = function () {
          btn.classList.add('is-copied');
          btn.textContent = '✓';
          setTimeout(function () {
            btn.classList.remove('is-copied');
            btn.textContent = '📋';
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    });

    /* ---------- Delivery countdown ---------- */
    var timer = root.querySelector('[data-ugma-timer]');
    if (timer) {
      var valueEl = timer.querySelector('[data-ugma-timer-value]');
      var cutoffHour = parseInt(timer.dataset.cutoffHour, 10);
      var tzOffset = parseFloat(timer.dataset.tzOffset);
      if (isNaN(cutoffHour)) cutoffHour = 17;
      if (isNaN(tzOffset)) tzOffset = 0;

      var tick = function () {
        // current time in store timezone
        var now = new Date();
        var utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
        var storeNow = new Date(utcMs + tzOffset * 3600000);
        var cutoff = new Date(storeNow);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        if (storeNow >= cutoff) {
          cutoff.setDate(cutoff.getDate() + 1);
        }
        var diff = Math.max(0, cutoff - storeNow);
        var totalMin = Math.floor(diff / 60000);
        var h = Math.floor(totalMin / 60);
        var m = totalMin % 60;
        var parts = [];
        if (h > 0) parts.push(h + ' hr' + (h === 1 ? '' : 's'));
        parts.push(m + ' min' + (m === 1 ? '' : 's'));
        if (valueEl) valueEl.textContent = parts.join(' ');
      };
      tick();
      setInterval(tick, 30000);
    }

    /* ---------- Mobile description "Read more" (4-line clamp) ---------- */
    var descBody = root.querySelector('[data-ugma-desc-body]');
    var descToggle = root.querySelector('[data-ugma-desc-toggle]');
    if (descBody && descToggle) {
      var mq = window.matchMedia('(max-width: 989px)');

      var collapse = function () {
        descBody.classList.remove('is-expanded');
        descToggle.textContent = 'Read more';
      };

      var applyClamp = function () {
        if (mq.matches) {
          descBody.classList.add('ugma-desc__body--clamp');
          collapse();
          // Measure overflow while clamped; only show the button if text is cut off.
          var overflowing = descBody.scrollHeight > descBody.clientHeight + 1;
          if (overflowing) {
            descToggle.hidden = false;
            descToggle.classList.add('is-visible');
          } else {
            descToggle.hidden = true;
            descToggle.classList.remove('is-visible');
          }
        } else {
          descBody.classList.remove('ugma-desc__body--clamp', 'is-expanded');
          descToggle.hidden = true;
          descToggle.classList.remove('is-visible');
        }
      };

      descToggle.addEventListener('click', function () {
        var expanded = descBody.classList.toggle('is-expanded');
        descToggle.textContent = expanded ? 'Read less' : 'Read more';
      });

      applyClamp();
      if (mq.addEventListener) {
        mq.addEventListener('change', applyClamp);
      } else if (mq.addListener) {
        mq.addListener(applyClamp);
      }
    }

    /* ---------- Sticky add-to-cart bar ---------- */
    var sticky = root.querySelector('[data-ugma-sticky]');
    var stickyBtn = root.querySelector('[data-ugma-sticky-atc]');
    // Anchor on the main buy buttons: show the sticky bar once they scroll above the viewport.
    var anchor = root.querySelector('.ugma-actions') || root.querySelector('.product-form__submit');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', scrolledPast);
            sticky.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
          });
        },
        { threshold: 0 }
      );
      stickyObserver.observe(anchor);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // Reuse the real product form so quantity, variant and cart drawer all behave normally.
        var submit = root.querySelector('.product-form__submit');
        if (submit) {
          submit.click();
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-ugma-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: re-init when section reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ugma-product]');
    if (el) init(el);
  });
})();
